import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';

import type { Locale, RawTranslations } from './types';

export type FeatureName = string;
export type StringKey = string;

export interface FeatureTranslationFullfilled {
  readonly status: 'fulfilled';
  readonly strings: RawTranslations;
}

export interface FeatureTranslationPending {
  readonly status: 'pending';
}

export interface FeatureTranslationRejected {
  readonly status: 'rejected';
  readonly error: unknown;
}

export type FeatureTranslation = FeatureTranslationFullfilled | FeatureTranslationPending | FeatureTranslationRejected;

export type Translations = Record<FeatureName, FeatureTranslation>;

export interface I18nState {
  readonly currentLocale: Locale;
  readonly previousLocale: Locale;
  readonly translations: Translations;
}

export const initialI18nState: I18nState = {
  currentLocale: '',
  previousLocale: '',
  translations: {},
};

export const useI18nStore: UseBoundStore<StoreApi<I18nState>> = create<I18nState>()(() => initialI18nState);
